// extracted by mini-css-extract-plugin
module.exports = {"phonetics":"Phonetics_phonetics__3E7M6"};